import { render, staticRenderFns } from "./appVersionList.vue?vue&type=template&id=71137bea&scoped=true&"
import script from "./appVersionList.vue?vue&type=script&lang=js&"
export * from "./appVersionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71137bea",
  null
  
)

export default component.exports